import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AppConsts from '@/lib/AppConsts';
import { StartUp } from '@/lib/startup';
import ExternalLoginService from '@/lib/auth/ExternalLoginService';
import { StateModel } from '@/lib/auth/StateModel';
import Util from '@/lib/util';
import { AuthenticateModel } from '@/lib/service-proxy/AuthenticateModel';
import { TokenAuthServiceProxy } from '@/lib/service-proxy/TokenAuthServiceProxy';
import LoadingPage from '@/views/loadingPage/loadingPage.vue';
var Login = /** @class */ (function (_super) {
    tslib_1.__extends(Login, _super);
    function Login() {
        var _this = _super.call(this) || this;
        _this.authModel = new AuthenticateModel();
        _this.loginProviders = [];
        _this.loading = false;
        _this.agreement = false;
        _this.showLoginView = false;
        _this.tokenService = new TokenAuthServiceProxy();
        _this.externalLoginService = new ExternalLoginService();
        return _this;
    }
    Login.prototype.beforeCreate = function () {
    };
    Login.prototype.created = function () {
    };
    Login.prototype.mounted = function () {
        var _this = this;
        this.getLoginProviders().then(function () {
            _this.loginWithWeChat();
        });
    };
    Login.prototype.login = function () {
        var _this = this;
        this.loading = true;
        this.tokenService.authenticate(this.authModel)
            .then(function (result) {
            abp.auth.setToken(result.accessToken);
            abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, result.encryptedAccessToken, undefined, abp.appPath);
            StartUp().then(function () {
                _this.$router.replace(_this.$route.query.returnUrl);
            });
        }).finally(function () {
            _this.loading = false;
        });
    };
    Login.prototype.submit = function () {
        // if (this.$validator.errors.items.length > 0 || this.loading) {
        //     return;
        // }
        if (!!this.authModel.userNameOrEmailAddress && !!this.authModel.password) {
            this.login();
        }
        else {
            abp.message.warn('请输入账号密码！', '错误');
        }
    };
    Login.prototype.loginWithWeChat = function () {
        if (navigator.userAgent.indexOf('MicroMessenger') > 0) {
            var weixinProvider = this.loginProviders.find(function (item) {
                return item.name.toLocaleLowerCase() === 'weixin';
            });
            if (weixinProvider && AppConsts.authorization.enableExternalLogin) {
                this.redirectOauth(weixinProvider.name, weixinProvider.clientId, this.$route.query.returnUrl);
            }
        }
        else {
            this.showLoginView = true;
        }
    };
    Login.prototype.getLoginProviders = function () {
        var _this = this;
        return this.tokenService
            .getExternalAuthenticationProviders()
            .then(function (result) {
            _this.loginProviders = result;
        });
    };
    Login.prototype.redirectOauth = function (providerName, clientId, returnUrl) {
        var redirectUri = Util.BaseUrl + (this.$router.mode === 'hash' ? '#/' : '') + 'callback';
        var stateModel = new StateModel();
        stateModel.returnUrl = returnUrl;
        stateModel.provider = providerName;
        var stateStr = this.externalLoginService.getState(stateModel);
        if (providerName.toLocaleLowerCase() === 'weixin' ||
            providerName.toLocaleLowerCase() === 'wechat') {
            if (navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > 0) {
                window.location.href =
                    'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +
                        clientId +
                        '&redirect_uri=' +
                        encodeURIComponent(redirectUri) +
                        '&response_type=code&scope=snsapi_userinfo&state=' +
                        encodeURIComponent(stateStr) +
                        '#wechat_redirect';
            }
            else {
                window.location.href =
                    'https://open.weixin.qq.com/connect/qrconnect?' +
                        'appid=' +
                        clientId +
                        '&redirect_uri=' +
                        encodeURIComponent(redirectUri) +
                        '&response_type=code&scope=snsapi_login,snsapi_userinfo&state=' +
                        encodeURIComponent(stateStr) +
                        '#wechat_redirect';
            }
        }
    };
    Login = tslib_1.__decorate([
        Component({
            components: { LoadingPage: LoadingPage }
        })
    ], Login);
    return Login;
}(Vue));
export default Login;
